import { Divider, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
import styles from './InvoiceViewLineItem.module.scss';
import rpcShared from '@rockpapercoin/rpc-shared';

type CellProps = {
	value: string | number | null | undefined;
	label?: string;
	isMobile: boolean;
	className?: string;
};

const Cell: React.FC<CellProps> = ( { value, label, isMobile, className } ) => (
	<ListItemText
		className={ [ isMobile && !!label ? 'mobile-view' : undefined, className, ].join( ' ' ) }
		disableTypography={ ( isMobile && !!label ) || false }
	>
		{ isMobile && !!label ? (
			<>
				<Typography component='span'>{ label }</Typography>
				<Typography component='span'>{ value }</Typography>
			</>
		) : (
			value
		) }
	</ListItemText>
);

export type InvoiceViewLineItemProps = {
	lineItem: NonNullable<
	ReturnType<typeof rpcShared.invoices.calculateLineItemToString>
	> & { id: string; name: string; notes?: string | null };
	isMobile: boolean;
	rateLabel: string;
};

export const InvoiceViewLineItem: React.FC<InvoiceViewLineItemProps> = ( {
	lineItem,
	isMobile,
	rateLabel,
} ) => {
	return (
		<>
			<ListItem disableGutters data-cy={ lineItem.id }>
				<Cell
					value={ lineItem.name }
					isMobile={ isMobile }
					className={ styles.name }
				/>
				<Cell value={ lineItem.rate } label={ rateLabel } isMobile={ isMobile } />
				<Cell value={ lineItem.quantity } label='Quantity' isMobile={ isMobile } />
				<Cell value={ lineItem.taxPercentage } label='Tax' isMobile={ isMobile } />
				<Cell
					value={ lineItem.lineTotal }
					label='Line total'
					isMobile={ isMobile }
					className={ styles.amount }
				/>
				{ typeof lineItem.notes === 'string' && lineItem.notes.length > 0 ? (
					<Typography
						component='div'
						dangerouslySetInnerHTML={ { __html: lineItem.notes } }
						className={ styles.notes }
					/>
				) : null }
			</ListItem>
			<Divider />
		</>
	);
};
